export const URL_TARJETAS_DASHBOARD =
'/Facturacion/WebService/FacturacionWebService.asmx/BuscarTarjetasDashboard'
export const URL_PROMEDIO_VENTA_FACTURA_GRAFICO = 
'/Facturacion/WebService/FacturacionWebService.asmx/BuscarPromedioVentaFacaturaGrafico'
export const URL_PROMEDIO_ARTICULO_FACTURA_GRAFICO = 
'/Facturacion/WebService/FacturacionWebService.asmx/BuscarPromedioArticuloFacturaGrafico'
export const URL_TOP10_ITEMS_VENTA_GRAFICO = 
'/Facturacion/WebService/FacturacionWebService.asmx/BuscarTop10ArticuloVendidosGrafico'
export const URL_GANACIAS_GRAFICO = 
'/Facturacion/WebService/FacturacionWebService.asmx/BuscarGananciasGrafico'
export const URL_VENTAS_TOTALES_GRAFICO = 
'/Facturacion/WebService/FacturacionWebService.asmx/BuscarVentasTotalesGrafico'
export const URL_VENTAS_POR_ITEM_GRAFICO =
'/Facturacion/WebService/FacturacionWebService.asmx/BuscarVentasPorItemGrafico'
export const URL_RENTABILIDAD_POR_VENDEDOR_GRAFICO = 
'/Facturacion/WebService/FacturacionWebService.asmx/BuscarRentabilidadPorVendedorGrafico'

export const URL_TOP10_ITEMS_VENDIDOS = 
'/Facturacion/WebService/FacturacionWebService.asmx/buscarTops10ItemsVendidosDashboard'
export const URL_TOP10_VENDEDORES_COMISION = 
'/Facturacion/WebService/FacturacionWebService.asmx/buscarTops10VendedoresPorComision'
export const URL_TOP10_OFERTAS_VENDIDAS = 
'/Facturacion/WebService/FacturacionWebService.asmx/buscarTops10OfertasVendidasDashboard'
export const URL_TOP10_ITEMS_INGRESO = 
'/Facturacion/WebService/FacturacionWebService.asmx/buscarTops10ItemsIngresoDashboard'

export const URL_TIENDAS_GRID = 
'/Facturacion/WebService/TiendaWebService.asmx/BuscarListadoTiendas'
export const URL_TIENDAS_DATAGRID = 
'/Facturacion/WebService/FacturacionWebService.asmx/buscarGridTiendasDashboard'

export const URL_RENTABILIDAD_POR_ITEM_GRID =
'/Facturacion/WebService/FacturacionWebService.asmx/buscarRentabilidadPorItemGridDashboard'

export const URL_ITEMS_AUTOCOMPLETE =
'/Inventario/WebService/ItemWebService.asmx/BuscarListadoItems'

    